module.exports = {"610624001":"真武洞街道","610624101":"砖窑湾镇","610624102":"沿河湾镇","610624103":"招安镇","610624104":"化子坪镇","610624105":"坪桥镇","610624106":"建华镇","610624107":"高桥镇","610624108":"镰刀湾镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610624.json
// module id = 2629
// module chunks = 0